<template>
  <div>
    <v-card class="hvh-card--rounded px-4 py-4 mb-5">
      <div class="hvh-flex mt-4">
        <div class="mr-3">
          <v-card class="mb-4 hvh-card--rounded pt-4 px-4">
            <h2 class="hvh-h7 mb-1">Year Range</h2>
            <CohortRangeFilter class="mb-4" v-model="yearFromTo" :min="yearMin" :max="yearMax" />
            <Loader v-if="isLoadingMinMaxYearAgeRange" />
          </v-card>
          <v-card class="mb-4 hvh-card--rounded pt-4 px-4">
            <h2 class="hvh-h7 mb-1">Age Range</h2>
            <CohortRangeFilter class="mb-4" v-model="ageFromTo" :min="ageMin" :max="ageMax" />
            <Loader v-if="isLoadingMinMaxYearAgeRange" />
          </v-card>

          <v-card class="mb-4 hvh-card--rounded p-4">
            <h2 class="hvh-h7 mb-1">Gender</h2>
            <div>
              <HvhInputCheckbox :value="[-1, 1].includes(filterObject.demo.sex)" text="Male" @input="sexChanged(1)" />
              <HvhInputCheckbox :value="[-1, 2].includes(filterObject.demo.sex)" text="Female" @input="sexChanged(2)" />
            </div>
          </v-card>
          <v-card class="mb-4 hvh-card--rounded p-4">
            <h2 class="hvh-h7 mb-1">Insurance Type</h2>
            <div>
              <HvhInputCheckbox
                :value="!(filterObject.demo.medicalInsurance || []).any() || filterObject.demo.medicalInsurance.includes(item)"
                :text="item"
                @input="medicalInsuranceChanged(item)"
                :key="item + ind"
                v-for="(item, ind) in demographics.insurances"
              />
            </div>
          </v-card>
          <v-card class="mb-4 hvh-card--rounded p-4">
            <h2 class="hvh-h7 mb-1">State</h2>
            <div>
              <CohortStateSelectFilter :value="filterObject.area.states" @input="statesChanged" />
            </div>
          </v-card>
        </div>

        <div class="col-sm-12 col-md-9 col-lg-9 col-xl-9">
          <div>
            <v-btn class="hvh-btn hvh-btn--secondary" @click="exportModal.active = true"> Export Results </v-btn>
            <hvh-modal v-model="exportModal.active" title="Select Export and File Types">
              <template v-slot>
                <h3 class="hvh-h6">Raw Data</h3>
                <v-radio-group v-model="selectedFormat" row>
                  <v-layout>
                    <v-flex xs6 class="col-sm-12 col-md-6"> <v-radio label="Excel" value="excel"></v-radio><br /> </v-flex>
                    <v-flex xs6 class="col-sm-12 col-md-6">
                      <v-radio label=".csv" value="csv"></v-radio>
                    </v-flex>
                  </v-layout>
                </v-radio-group>
              </template>

              <template v-slot:actions>
                <v-btn @click="confirmDownload" flat class="hvh-btn hvh-btn--primary"> Export Analysis </v-btn>
              </template>
            </hvh-modal>
          </div>
          <div class="pl-3 pr-3 mt-3">
            <h3 class="text-center">Rx Rejection</h3>
            <SPCoreHorizontalBarChart class="col-sm-12 charts" title="Rx Rejection" :data="rxRejectionBarChartData" :filterObject="mergeFilter({ rxRejection: null })" :isFiltering="isFiltering.rxRejection" nameField="name" height:="600px"
            valueField="value" @refresh-data="loadRxRejectionData" @checked-changed="loadRxRejectionData" />
          </div>
        </div>
      </div>
    </v-card>
  </div>
</template>

<script>
import { getDemographics } from '../../libraries/cohorts';
import HvhInputCheckbox from '../common/form/inputCheckbox/HvhInputCheckbox.vue';
import CohortRangeFilter from '../analytics/cohorts/cohortFilters/CohortRangeFilter.vue';
import HvhModal from '../common/modal/HvhModal.vue';
import { createFormData, errorDebug, } from '../../libraries/common';
import SPCoreHorizontalBarChart from '../spcore/SPCoreHorizontalBarChart.vue';
import { mergeFilters, } from '../../libraries/common';
import CohortStateSelectFilter from '../analytics/cohorts/cohortFilters/CohortStateSelectFilter.vue';
import { stringifyLiveFilters } from '../../libraries/liveFilters';
import axios from '../../axios';
import LiveFiltersRibbon from '../analysis/filters/LiveFiltersRibbon.vue';
import ExcelJS from 'exceljs';
import { saveAs } from 'file-saver';

export default {

  components: { HvhInputCheckbox, CohortRangeFilter, HvhModal, CohortStateSelectFilter, LiveFiltersRibbon, SPCoreHorizontalBarChart },
  props: ['cohortId', 'runId'],
  data() {
    var demographics = getDemographics();
    return {
      filterObject: {
        area: {
          states: []
        },
        demo: {
          ageFrom: demographics.ageRange[0],
          ageTo: demographics.ageRange[1],
          medicalInsurance: [],
          sex: -1,
        },
        cohortId: this.cohortId,
        runId: this.runId,
      },
      yearMin: demographics.years[0],
      yearMax: demographics.years[1],
      ageMin: demographics.ageRange[0],
      ageMax: demographics.ageRange[1],
      isFiltering: {},
      demographics,
      isLoadingMinMaxYearAgeRange: false,
      cancelRequest: {},
      rxRejectionBarChartData: [],
      selectedFormat: '',
      exportModal:
      {
        active: false
      }
    };
  },
  computed: {
    ageFromTo: {
      get() {
        return [Math.max(this.filterObject.demo.ageFrom, this.ageMin), Math.min(this.filterObject.demo.ageTo, this.ageMax)];
      },
      set(value) {
        this.filterObject = {
          ...this.filterObject,
          demo: {
            ...this.filterObject.demo,
            ageFrom: parseInt(value[0]),
            ageTo: parseInt(value[1]),
          }
        };
      },
    },
    yearFromTo: {
      get() {
        var minMaxYears = [this.yearMin, this.yearMax];
        return [Math.max((this.filterObject.years || minMaxYears)[0], this.yearMin), Math.min((this.filterObject.years || minMaxYears)[1], this.yearMax)];
      },
      set(value) {
        this.filterObject = {
          ...this.filterObject,
          years: [...value.map(f => parseInt(f))],
        };
      }
    },
    isFilteringAny() {
      return Object.keys(this.isFiltering).find(key => this.isFiltering[key]);
    },

  },
  methods: {
    loadRxRejectionData(filterObject) {
      if (this.cancelRequest.rxRejection)
        this.cancelRequest.rxRejection();

      this.$set(this.isFiltering, 'rxRejection', true);

      axios.post('/RxRejection/GetData', {

        component: "RxRejection",
        ...stringifyLiveFilters(filterObject),
      }, {
        cancelToken: new axios.CancelToken(c => this.cancelRequest.rxRejection = c)
      }).then(response => {
        this.rxRejectionBarChartData = response.data.map(item => ({
          name: item.rejectDescription.capitalize(),
          value: item.patientCount,
          filterValue: item.rejectCode,
        }));
        this.$set(this.isFiltering, 'rxRejection', false);
      }).catch((error) => {
        if (!axios.isCancel(error)) {
          console.log(error);
          this.$set(this.isFiltering, 'rxRejection', false);
          this.disableIfTimeout(error);
        }
      });
    },
    getYearAndRangeData() {
      this.isLoadingMinMaxYearAgeRange = true;
      axios.post('/RxRejection/GetYearAndAgeRange', createFormData({ runId: this.runId, cohortId: this.cohortId }))
        .then(({ data }) => {
          this.yearMin = data.minYearRange;
          this.yearMax = data.maxYearRange;
          this.ageMin = data.minAge;
          this.ageMax = data.maxAge;
        })
        .catch(errorDebug)
        .then(() => this.isLoadingMinMaxYearAgeRange = false);
    },
    medicalInsuranceChanged(event) {
      var medicalInsurance = !this.filterObject.demo.medicalInsurance?.any() ? this.demographics.insurances : this.filterObject.demo.medicalInsurance;
      this.filterObject = {
        ...this.filterObject,
        demo: {
          ...this.filterObject.demo,
          medicalInsurance: medicalInsurance.toggle(event),
        },
      };
    },
    sexChanged(event) {
      var sex = this.filterObject.demo.sex === -1 ? [1, 2].toggle(event).first() : -1;
      this.filterObject = {
        ...this.filterObject,
        demo: {
          ...this.filterObject.demo,
          sex,
        },
      };
    },
    statesChanged(event) {
      this.filterObject = {
        ...this.filterObject,
        area: {
          ...this.filterObject.area,
          states: event,
        },
      };
    },
    mergeFilter(obj) {
      return mergeFilters(this.filterObject, obj);
    },
    confirmDownload() {
      this.exportModal.active = false;
      if (this.selectedFormat === 'excel') {
        this.exportToExcel();
      } else if (this.selectedFormat === 'csv') {
        this.exportToCsv();
      }
    },
    exportToExcel() {
      var data = this.rxRejectionBarChartData;
      var wb = new ExcelJS.Workbook();
      wb.addWorksheet('Rx_Rejection');
      const rxRejectionSheet = wb.getWorksheet('Rx_Rejection');
      rxRejectionSheet.columns = [
        { header: 'Rx_Description', key: 'Rx_Description' },
        { header: 'Patient_Count', key: 'Patient_Count' },
      ];

      for (let row of data) {
        rxRejectionSheet.addRow({
          Rx_Description: row.name,
          Patient_Count: row.value,
        });
      }
      wb.xlsx.writeBuffer().then(buffer => {
        var blob = new Blob([buffer], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });

        saveAs(blob, `Rx-Rejection-${this.runId}.xlsx`);

      });
    },
    exportToCsv() {
      var data = this.rxRejectionBarChartData;
      let csvContent = 'Rx_Description,Patient_Count\n';
      data.forEach(row => {
        let rxDescription = row.name ? `"${row.name.replace(/"/g, '""')}"` : '';
        let patientCount = row.value || 0;
        csvContent += `${rxDescription},${patientCount}\n`;
      });
      var blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
      saveAs(blob, `Rx-Rejection-${this.runId}.csv`);
    }
  },
  mounted() {
    if (process.env.NODE_ENV === 'development') window['thisRxRejection'] = this;
    this.getYearAndRangeData();
  }
}
</script>
<style lang="scss" scoped>
.top-right {
  position: absolute;
  top: 0;
  right: 0;
  margin: 10px 10px 0 0;
}
.rotate-90 {
  transform: rotate(180deg);
  writing-mode: vertical-rl;
  text-orientation: sideways;
}
.charts {
  height: 735px;
}
.hvh-btn {
  float: right;
  padding: 10px 10px;
  margin: 5px 30px;
}
</style>